import {
  ItemDetailsDto,
  ItemDetailsSidebarSectionResp,
} from '@marketplace-web/item-page/item-page-data'

import { ItemPageUserInfoDetailsPluginModel } from './types'

export const getItemPageUserInfoDetailsPluginModel = (
  itemDto: ItemDetailsDto,
): ItemPageUserInfoDetailsPluginModel => ({
  sellerId: itemDto.user.id,
  business: itemDto.user.business,
  businessAccount: itemDto.user.business_account,
  msgTemplateCount: itemDto.user.msg_template_count,
  isOnHoliday: itemDto.user.is_on_holiday,
  lastLogedOnTs: itemDto.user.last_loged_on_ts,
  exposeLocation: itemDto.user.expose_location,
  city: itemDto.user.city,
  countryTitleLocal: itemDto.user.country_title_local,
  itemId: itemDto.id,
})

export const getServerItemPageUserInfoDetailsPluginModel = (
  sidebarDto: ItemDetailsSidebarSectionResp,
): ItemPageUserInfoDetailsPluginModel => ({
  sellerId: sidebarDto.seller_id,
  business: sidebarDto.business,
  businessAccount: sidebarDto.business_account,
  msgTemplateCount: sidebarDto.msg_template_count,
  isOnHoliday: sidebarDto.is_on_holiday,
  lastLogedOnTs: sidebarDto.last_loged_on_ts,
  exposeLocation: sidebarDto.expose_location,
  city: sidebarDto.city,
  countryTitleLocal: sidebarDto.country_title_local,
  itemId: sidebarDto.id,
})
